import React from 'react'
import { Spin } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'

interface BackgroundRefreshSpinnerProps {
  isRefreshing: boolean
  size?: 'small' | 'default' | 'large'
}

/**
 * Small spinner component to show in page toolbars during background refresh
 */
export function BackgroundRefreshSpinner({ isRefreshing, size = 'small' }: BackgroundRefreshSpinnerProps) {
  if (!isRefreshing) {
    return null
  }

  return (
    <Spin
      indicator={<ReloadOutlined spin style={{ fontSize: size === 'small' ? 14 : 16, color: '#1890ff' }} />}
      size={size}
    />
  )
}
